module.exports = __webpack_public_path__ + "img/Enercoop_120X35.19a3aca6.png";